import { render, staticRenderFns } from "./wine-collections-investor3.vue?vue&type=template&id=015c9890&scoped=true"
import script from "./wine-collections-investor3.vue?vue&type=script&lang=js"
export * from "./wine-collections-investor3.vue?vue&type=script&lang=js"
import style0 from "./wine-collections-investor3.vue?vue&type=style&index=0&id=015c9890&prod&scoped=true&lang=css"
import style1 from "./wine-collections-investor3.vue?vue&type=style&index=1&id=015c9890&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c9890",
  null
  
)

export default component.exports